//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var BASE_URL = '/prototype/accounting/general-ledger/budgets';

export default {
    data: function data() {
        return {
            budget: {},
            name: moment().format("YYYY") + ' Budget',
            start: moment().startOf('year').format("MM/DD/YYYY"),
            end: moment().endOf('year').format("MM/DD/YYYY"),
            budgetValidations: [{ model: 'name', rules: 'required' }, { model: 'start', rules: 'required | date' }, { model: 'end', rules: 'required | date' }]
        };
    },
    mounted: function mounted() {
        var _this = this;

        var $el = this;

        Event.$on('add-new-budget', function () {
            _this.$initValidator();
            _this.$children[0].$data.showSmallModal = true;
        });
    },


    methods: {
        save: function save() {
            this.validator.setRules(this.budgetValidations).validate();
            if (this.validator.fails()) {
                return;
            }

            this.budget.name = this.name;
            this.budget.start = this.start;
            this.budget.end = this.end;
            axios.post(BASE_URL + '/store', this.budget).then(function (response) {
                Event.$emit('edit-budget', response.data);
                Event.$emit('refresh-gl-budgets');
                Event.$emit('close-small-modal');
            });
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/accounting/general-ledger/budget/AddBudget.vue
// module id = iTzY
// module chunks = 0 1